import React, { useEffect, useMemo, useState } from "react";
import {
  Row,
  Col,
  Layout,
  Card,
  Typography,
  Select,
  List,
  Avatar,
  Space,
  DatePicker,
  Modal,
  Spin,
  Breadcrumb,
} from "antd";
import "../dashboard/styles/index.less";
import { get_all_visitor } from "../../services/visitor";
import { get_all_user } from "../../services/user";
import {
  get_task_active,
  get_task_dataset_count,
  getDashboardData,
  getDashboardDatasetAll,
  getDashboardDatasetTop5,
  getDashboardTaskAll,
  getDashboardTaskTop5,
  getExportDashboard,
} from "../../services/task";
import ExportExcel from "./component/exportExcel";
import locale from "antd/es/date-picker/locale/th_TH";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const colors = ["#FF5733", "#33A1FF", "#FF33A1", "#75FF33", "#FF9933"];

const { Content } = Layout;
const { Title, Text } = Typography;
const { Option } = Select;

const Dashboard = () => {
  const [visitor, setVisitor] = useState(0);
  const [user, setUser] = useState(0);
  const [task, setTask] = useState(0);
  const [countdataset, setCountDataset] = useState(0);
  const [activitiesData, setActivitiesData] = useState<any>([]);
  const [userSubmission, setUserSubmission] = useState<any>([]);
  const [datasetData, setDatasetData] = useState<any>();
  const [activitiesDataAll, setActivitiesDataAll] = useState<any>([]);
  const [datasetDataAll, setDatasetDataAll] = useState<any>();
  const [isModalActive, setIsModalActive] = useState<any>(false);
  const [isModalDataset, setIsModalDataset] = useState<any>(false);

  const [isLoadingData, setIsLoadingData] = useState(true);
  const { t } = useTranslation();

  // get api
  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingData(true);
      await getVisitor();
      await getUser();
      await getTask();
      await getDataset();
      await getDataTop5();
      await getDataExportDashboard();
      await getDataDashboard();
      await getDataALl();
      setIsLoadingData(false);
    };
    fetchData();
  }, []);

  const getVisitor = async () => {
    try {
      const res = await get_all_visitor();
      setVisitor(res.result.length);
    } catch (e) {
      console.error(e);
    }
  };

  const getDataset = async () => {
    try {
      const res = await get_task_dataset_count();
      setCountDataset(res.result);
    } catch (e) {
      console.error(e);
    }
  };

  const getUser = async () => {
    try {
      const res = await get_all_user();
      setUser(res.result.length);
    } catch (e) {
      console.error(e);
    }
  };

  const getTask = async () => {
    try {
      const res = await get_task_active({
        fields: ["*"],
        filter: {
          status: 1,
        },
      });
      setTask(res.result.length);
    } catch (e) {
      console.error(e);
    }
  };

  const getDataExportDashboard = async () => {
    try {
      const res = await getExportDashboard();
      // setUserSubmission(res.data.user_submission);
    } catch (e) {
      console.error(e);
    }
  };

  const getDataDashboard = async (date?: any, type?: any) => {
    try {
      const data = {
        typeSelect: type ? type : typeSelect,
        month: dayjs(date ? date : dateSelect).format("MM"),
        year: dayjs(date ? date : dateSelect).format("YYYY"),
      };
      const res = await getDashboardData(data);
      if (res.status == "success") {
        setVisitor(res.data.visitor);
        setUser(res.data.user);
        setCountDataset(res.data.dataset);
        setTask(res.data.task);
        setUserSubmission(res.data.user_submission);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getDataTop5 = async (date?: any, type?: any) => {
    try {
      const data = {
        typeSelect: type ? type : typeSelect,
        month: dayjs(date ? date : dateSelect).format("MM"),
        year: dayjs(date ? date : dateSelect).format("YYYY"),
      };
      const task = await getDashboardTaskTop5(data);
      const dataSet = await getDashboardDatasetTop5(data);
      const task_result = task.data.map((item: any) => {
        return {
          key: item.task_id,
          activity: item.name,
          usage: item.count,
        };
      });

      const dataSet_result = dataSet.data.map((item: any) => {
        return {
          key: item.task_id,
          dataset: item.name,
          usage: item.count,
        };
      });
      setActivitiesData(task_result);
      setDatasetData(dataSet_result);
    } catch (e) {
      console.error(e);
    }
  };

  const getDataALl = async (date?: any, type?: any) => {
    try {
      const data = {
        typeSelect: type ? type : typeSelect,
        month: dayjs(date ? date : dateSelect).format("MM"),
        year: dayjs(date ? date : dateSelect).format("YYYY"),
      };
      const task = await getDashboardTaskAll(data);
      const dataSet = await getDashboardDatasetAll(data);
      const task_result = task.data.map((item: any) => {
        return {
          key: item.task_id,
          activity: item.name,
          usage: item.count,
        };
      });

      const dataSet_result = dataSet.data.map((item: any) => {
        return {
          key: item.task_id,
          dataset: item.name,
          usage: item.count,
        };
      });
      setActivitiesDataAll(task_result);
      setDatasetDataAll(dataSet_result);
    } catch (e) {
      console.error(e);
    }
  };

  // =================================
  const [typeSelect, setTypeSelect] = useState<any>("month");
  const [dateSelect, setDateSelect] = useState<any>(dayjs());

  const handleChangeDate = (value: any) => {
    try {
      setDateSelect(dayjs(value));
      getDataDashboard(dayjs(value), typeSelect);
      getDataTop5(dayjs(value), typeSelect);
      getDataALl(dayjs(value), typeSelect);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSelectType = (value: any) => {
    try {
      setTypeSelect(value);
      getDataDashboard(dateSelect, value);
      getDataTop5(dateSelect, value);
      getDataALl(dateSelect, value);
    } catch (e) {
      console.error(e);
    }
  };

  
  return (
    <div>
      <Layout>
        {/* Top content section */}
        <Content className="dashboard-layout">
          <div>
            <Row justify="space-between" align="middle">
              <Breadcrumb
                separator=">"
                items={[
                  {
                    title: (
                      <span style={{ fontWeight: "bold" }}>
                        {t("Dashboard")}
                      </span>
                    ),
                  },
                ]}
              />
              <Space wrap>
                <Title
                  level={5}
                  style={{ marginBottom: "0px", paddingRight: "10px" }}
                >
                  {t("Show results")} :
                </Title>
                <Select
                  defaultValue={t("Monthly")}
                  onSelect={handleSelectType}
                  style={{ width: 120 }}
                >
                  <Select.Option value="month">{t("Monthly")}</Select.Option>
                  <Select.Option value="year">{t("Annual")}</Select.Option>
                </Select>
                {typeSelect == "month" ? (
                  <DatePicker
                    locale={locale}
                    value={dateSelect}
                    format={"MMM YYYY"}
                    onChange={handleChangeDate}
                    allowClear={false}
                    picker="month"
                    inputReadOnly
                  />
                ) : (
                  <DatePicker
                    locale={locale}
                    value={dateSelect}
                    format={"YYYY"}
                    onChange={handleChangeDate}
                    allowClear={false}
                    picker="year"
                  />
                )}
                <ExportExcel />
              </Space>
            </Row>
            <hr />
          </div>
        </Content>

        {/* Cards section */}
        <Content className="bodydashboard-layout">
          {isLoadingData ? (
            // ✅ แสดง Loading
            <Row justify="center" align="middle" style={{ height: "50vh" }}>
              <Spin size="large" />
            </Row>
          ) : (
            <>
              <Row
                gutter={[16, 16]}
                justify="space-around"
                style={{ marginBottom: "1.5rem" }}
              >
                <Col xs={24} sm={12} md={6}>
                  <Card style={{ borderColor: "#050C9C" }}>
                    <Col>
                      <Text style={{ fontSize: "20px" }}>{t("Number of visitors")}</Text>
                    </Col>
                    <Col>
                      <Row justify={"center"} style={{ padding: "10px" }}>
                        <Text
                          style={{
                            fontSize: "40px",
                            color: "#050C9C",
                            fontWeight: "bold",
                          }}
                        >
                          {visitor}
                        </Text>
                      </Row>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                      <Text style={{ fontSize: "20px" }}>{t("Time")}</Text>
                    </Col>
                  </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Card style={{ borderColor: "#3572EF" }}>
                    <Col>
                      <Text style={{ fontSize: "20px" }}>
                        {t("Number of tasks or activities")}
                      </Text>
                    </Col>
                    <Col>
                      <Row justify={"center"} style={{ padding: "10px" }}>
                        <Text
                          style={{
                            fontSize: "40px",
                            color: "#3572EF",
                            fontWeight: "bold",
                          }}
                        >
                          {task}
                        </Text>
                      </Row>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                      <Text style={{ fontSize: "20px" }}>{t("Task")}</Text>
                    </Col>
                  </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Card style={{ borderColor: "#EE4E4E" }}>
                    <Col>
                      <Text style={{ fontSize: "20px" }}>
                        {t("Number of registered users")}
                      </Text>
                    </Col>
                    <Col>
                      <Row justify={"center"} style={{ padding: "10px" }}>
                        <Text
                          style={{
                            fontSize: "40px",
                            color: "#EE4E4E",
                            fontWeight: "bold",
                          }}
                        >
                          {user}
                        </Text>
                      </Row>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                      <Text style={{ fontSize: "20px" }}>{t("Use")}</Text>
                    </Col>
                  </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Card style={{ borderColor: "#FF7D29" }}>
                    <Col>
                      <Text style={{ fontSize: "20px" }}>
                        {t("Number of users testing the model")}
                      </Text>
                    </Col>
                    <Col>
                      <Row justify={"center"} style={{ padding: "10px" }}>
                        <Text
                          style={{
                            fontSize: "40px",
                            color: "#FF7D29",
                            fontWeight: "bold",
                          }}
                        >
                          {userSubmission}
                        </Text>
                      </Row>
                    </Col>
                    <Col style={{ textAlign: "center" }}>
                      <Text style={{ fontSize: "20px" }}>{t("Use")}</Text>
                    </Col>
                  </Card>
                </Col>
              </Row>

              {/* Download Section */}
              <Card>
                <Row justify="space-between" align="middle">
                  <Col>
                    <Text style={{ fontSize: "20px" }}>
                      {t("Number of dataset downloads")}
                    </Text>
                  </Col>
                  <Col>
                    <Row align="middle">
                      <Title
                        level={2}
                        style={{ marginBottom: "0px", marginRight: "30px" }}
                      >
                        {countdataset}
                      </Title>
                      <Text style={{ fontSize: "20px" }}>{t("Time")}</Text>
                    </Row>
                  </Col>
                </Row>
              </Card>

              {/* Popular Items Section */}
              <Row gutter={[16, 16]} style={{ marginTop: "24px" }}>
                <Col xs={24} md={12}>
                  <Card
                    title={t("Top 5 most popular events or activities")}
                    extra={
                      <div
                        className="cl-all"
                        onClick={() => setIsModalActive(true)}
                      >
                        {t("Show All")}
                      </div>
                    }
                  >
                    <List
                      dataSource={activitiesData}
                      renderItem={(item: any, index: any) => (
                        <List.Item>
                          <List.Item.Meta
                            avatar={
                              <Avatar
                                style={{
                                  backgroundColor:
                                    colors[index % colors.length],
                                }}
                              >
                                {item.activity.charAt(0)}
                              </Avatar>
                            }
                            title={item.activity}
                          />
                          <div>{item.usage} {t("User Active")}</div>
                        </List.Item>
                      )}
                    />
                  </Card>
                </Col>
                <Col xs={24} md={12}>
                  <Card
                    title={t("Top 5 Most Popular Datasets")}
                    extra={
                      <div
                        className="cl-all"
                        onClick={() => setIsModalDataset(true)}
                      >
                        {t("Show All")}
                      </div>
                    }
                  >
                    <List
                      dataSource={datasetData}
                      renderItem={(item: any, index: any) => (
                        <List.Item>
                          <List.Item.Meta
                            avatar={
                              <Avatar
                                style={{
                                  backgroundColor:
                                    colors[index % colors.length],
                                }}
                              >
                                {item.dataset.charAt(0)}
                              </Avatar>
                            }
                            title={item.dataset}
                          />
                          <div>{item.usage} {t("Time")}</div>
                        </List.Item>
                      )}
                    />
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </Content>
      </Layout>


      <Modal
        title={t("Ranking of tasks or activities")}
        open={isModalActive}
        onCancel={() => setIsModalActive(false)}
        footer={false}
      >
        <>
          <List
            style={{ overflowY: "auto", height: "450px", padding: "20px" }}
            dataSource={activitiesDataAll}
            renderItem={(item: any, index: any) => (
              <List.Item>
                <List.Item.Meta
                  avatar={
                    <Avatar
                      style={{
                        backgroundColor: colors[index % colors.length],
                      }}
                    >
                      {item.activity.charAt(0)}
                    </Avatar>
                  }
                  title={<div className="text-limit">{item.activity}</div>}
                />
                <div>{item.usage} {t("Use")}</div>
              </List.Item>
            )}
          />
        </>
      </Modal>


      
      <Modal
        title={t("Dataset Rank")}
        open={isModalDataset}
        onCancel={() => setIsModalDataset(false)}
        footer={false}
      >
        <>
          <List
            style={{ overflowY: "auto", height: "450px", padding: "20px" }}
            dataSource={datasetDataAll}
            renderItem={(item: any, index: any) => (
              <List.Item>
                <List.Item.Meta
                  avatar={
                    <Avatar
                      style={{
                        backgroundColor: colors[index % colors.length],
                      }}
                    >
                      {item.dataset.charAt(0)}
                    </Avatar>
                  }
                  title={<div className="text-limit">{item.dataset}</div>}
                />
                <div>{item.usage} {t("Time")}</div>
              </List.Item>
            )}
          />
        </>
      </Modal>
    </div>
  );
};

export default Dashboard;
